import { createSlice } from "@reduxjs/toolkit";
import { inquirySubmit } from "./inquiryservice";

const initialState = {

    inquiryDetails: {
        isInquiryLoading: null,
        isInquiry: null,
        inquiryMessage: null,
    },
};

const inquirySlice = createSlice({
    name: "inquiry",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // 🔐 SignUp
            .addCase(inquirySubmit.pending, (state) => {
                state.inquiryDetails = {
                    ...initialState.inquiryDetails,
                    isInquiryLoading: true,
                    inquiryMessage: "Loading SignUp....",
                };
            })
            .addCase(inquirySubmit.rejected, (state, action) => {
                state.inquiryDetails = {
                    ...initialState.inquiryDetails,
                    isInquiryLoading: false,
                    isInquiry: false,
                    inquiryMessage: action.payload?.message || "Inquiry failed.",
                };
            })
            .addCase(inquirySubmit.fulfilled, (state, action) => {
                state.inquiryDetails = {
                    ...initialState.inquiryDetails,
                    isInquiryLoading: false,
                    isInquiry: true,
                    inquiryMessage: action.payload.message,
                };
            });
    },
});

export default inquirySlice.reducer;